import React, { useState } from 'react';
import { DndContext, PointerSensor, KeyboardSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { SortableOverlay } from './sortable/sortable-overlay';

interface Props {
  items: string[];
  onSortEnd(newItems: string[]): void;
  renderItem: (item: string, isActive?: boolean) => React.ReactNode;
}

export function SortableSimpleList({ items, onSortEnd, renderItem }: Props) {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
  const [activeId, setActiveId] = useState<string | null>(null);

  const handleDragStart = (event: any) => {
    setActiveId(event.active.id);
  };

  const handleDragEnd = (event: any) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = items.indexOf(active.id);
      const newIndex = items.indexOf(over.id);
      const newItems = arrayMove(items, oldIndex, newIndex);
      onSortEnd(newItems);
    }

    setActiveId(null);
  };

  return (
    <DndContext
      sensors={sensors}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragCancel={() => {
        setActiveId(null);
      }}
    >
      <SortableContext items={items}>{items.map((item) => renderItem(item))}</SortableContext>
      <SortableOverlay>{activeId ? renderItem(activeId, true) : null}</SortableOverlay>
    </DndContext>
  );
}
